import APIService from './APIService';

export default {
  getDados(dashboard, params = {}) {
    return APIService.apiCall().get(`/dashboard/get-dados/${dashboard}`, { params });
  },
  getDashboards() {
    return APIService.apiCall().get('/dashboard/get-dashboards');
  },
  getRegionais() {
    return APIService.apiCall().get('/dashboard/get-regionais');
  },
  getMunicipiosPorRegional(regional) {
    return APIService.apiCall().get('/dashboard/get-municipios', {
      params: { regional }
    });
  },
  getConjuntosPorRegional(regional) {
    return APIService.apiCall().get('/dashboard/get-conjuntos', {
      params: { regional }
    });
  }
};
